import { configureStore } from '@reduxjs/toolkit';
import servicesReducer from './slices/servicesSlice';
import orderReducer from './slices/orderSlice';
import notificationReducer from './slices/notificationSlice';
import provisioningReducer from './slices/provisioningSlice';
import userReducer from './slices/userSlice';

export const store = configureStore({
  reducer: {
    services: servicesReducer,
    order: orderReducer,
    notifications: notificationReducer,
    provisioning: provisioningReducer,
    user: userReducer,
  },
});

export default store;
